import api, {
  setHeaderToken,
  removeHeaderToken
} from '../../../apis/Api';
import config from '../../../config'

import router from '@/router'

export default {
  namespaced: true,
  state: {
    emailTemplateList: {},
  },
  getters: {
    getEmailTemplateList(state) {
      return state.emailTemplateList;
    },
  },
  mutations: {
    setEmailTemplateList(state, payload) {
      state.emailTemplateList = payload;
    },
  },
  actions: {
    updateEmailTemplate({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          baseURL: config('api.baseUrl_email'),
          method: payload.method,
          url: payload.url,
          data: payload.data,
          params: payload.params,
          withCredentials: true,
          headers: {
            'Authorization': 'Bearer ' + token,
          }
        }).then((res) => {
          resolve(res)
          dispatch('setLoading', false)
        }).catch((err) => {
          console.log('authjs=err' + err)
          reject(err);
          dispatch('setLoading', false)
          return false
        })
      })
    },
    getEmailTemplateList({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        baseURL: config('api.baseUrl_email'),
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          console.log('res.respond',res.respond)
          // const mailTemp = _.groupBy(res.respond.data, 'template_group');
          Array.prototype.groupBy = function(k) {
            return this.reduce((acc, item) => ((acc[item[k]] = [...(acc[item[k]] || []), item]), acc),{});
          };
          const mailTemp = res.respond.data.groupBy("template_group")
          // const mailTemp = res.respond.data.groupBy(o => {
          //   return o.template_group;
          // });
          console.log('mailTemp==',mailTemp)
          commit("setEmailTemplateList", mailTemp);
        } else if (res.respond.status == "forbidden") {
          localStorage.removeItem("token")
          localStorage.removeItem("refreshToken")
          router.push(`/login`).catch(() => { });
        }
        dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        dispatch('setLoading', false)
        return false
      })
    },

    setLoading({
      commit
    }, payload) {
      commit("loader/setLoading", payload, {
        root: true,
      });
    },
  },
};